module.exports = __webpack_public_path__ + "img/dec4_02.f6712acb.jpeg";